import { ClientEvent } from "@kiwicom/nitro/lib/records/Event"

import { TrackingModule } from "./constants/trackingEventTypes"

type Destinations = ClientEvent<TrackingModule>["destinations"]

export const defaultDestinations: Destinations = {
  logmole: true,
  datadog: true,
  bigQuery: true,
  exponea: false,
  ga: false,
}

/**
 * Returns event log data for Nitro's logger. Respects new formats which are
 * part of unification process in event-schemas repo
 * https://gitlab.skypicker.com/mobile/event-schemas.
 *
 * @param category {Category} - category of the event, eg. "paid guarantee".
 * @param action {Action} - action event, eg. "Button Clicked"
 * @param detail {string} - is prepended to action, eg. "Pay"
 * @param destinations {Destinations} - is set to defaultDestinations if not passed
 *
 * @example
 * log(createEventLog(PaidGuaranteeModule, UIAction.ButtonClicked, "Pay"))
 *
 * @returns - shape for Nitro's logger
 */
export const createEventLogUnified = (
  category: TrackingModule,
  action: string,
  detail?: string,
  destinations: Destinations = defaultDestinations,
): ClientEvent<TrackingModule> => ({
  category,
  action: detail ? `${detail} ${action}` : action,
  destinations,
})
